export const shareTwitter = (text, grUrl) => {
  const encodedText = encodeURIComponent(text)
  const url = `https://twitter.com/intent/tweet?text=${encodedText}&url=${grUrl}`
  window.open(url, '_blank')
}

export const shareTelegram = (text, grUrl) => {
  const encodedText = encodeURIComponent(text)
  const url = `https://t.me/share/url?url=${grUrl}&text=${encodedText}`
  window.open(url, '_blank')
}

export const shareWhatsApp = (text, grUrl) => {
  const encodedText = encodeURIComponent(text)
  const url = `https://api.whatsapp.com/send?text=${encodedText}%20%20${grUrl}`
  window.open(url, '_blank')
}
